import {
    globalAxios,
    backendVersion,
    managerInstance,
    merchantInstance,
} from "@/axios-path.js";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        withdrawlist: [],
        district: [],
    },
    mutations: {
        getDataWithdrawList(state, data) {
            state.withdrawlist = data;
        },
        setDistrcitCommissionWithdraw(state, data) {
            state.district = data;
        },
    },

    actions: {

        async fetchWithdrawList({ commit }, config) {
            let url = backendVersion.version + "/partner/get_commission_withdraw";
            return managerInstance
                .get(url, { params: config })
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("getDataWithdrawList", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return [];
                });

        },

        async fetchDistrcitCommissionWithdraw({ commit }, { manager_id }) {
            let url = `${backendVersion.version
                }/partner/get_district_commission_withdraw?province_id=${manager_id}`;
            return managerInstance
                .get(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("setDistrcitCommissionWithdraw", res.data);
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async deleteCommissionWithdraw({ commit, dispatch }, id) {
            let url = backendVersion.version + "/partner/delete_commission_withdraw/" + id;
            return managerInstance
                .delete(url, id)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async commissionWithdraw({ dispatch }, payload) {
            let url = backendVersion.version + "/partner/create_commission_withdraw"
            const item = {
                commission_withdraw_type: payload.commission_withdraw_type,
                commission_withdraw_province_id: payload.commission_withdraw_province_id,
                commission_withdraw_district_id: payload.commission_withdraw_district_id,
                commission_withdraw_amount: payload.commission_withdraw_amount,
                commission_withdraw_commission_maximun: payload.commission_withdraw_commission_maximun
            }
            return managerInstance
                .post(url, item)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async commissionWithdrawEdit({ dispatch }, payload) {
            let url = backendVersion.version + "/partner/update_commission_withdraw"
            const item = {
                commission_withdraw_id: payload.commission_withdraw_id,
                commission_withdraw_type: payload.commission_withdraw_type,
                commission_withdraw_province_id: payload.commission_withdraw_province_id,
                commission_withdraw_district_id: payload.commission_withdraw_district_id,
                commission_withdraw_amount: payload.commission_withdraw_amount,
                commission_withdraw_commission_maximun: payload.commission_withdraw_commission_maximun
            }
            return managerInstance
                .put(url, item)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        }
    },
    getters: {},
};
